<template>
  <div
    style="position: relative"
    class="d-flex flex-wrap align-items-center gap-2"
  >
    <div class="d-flex align-items-center">
      <b-form-select
        class="flex-1"
        :modelValue="operator"
        @update:modelValue="updateOperator"
        :options="options"
        size="sm"
      ></b-form-select>
    </div>
    <div v-if="operator !== 'isnull' && operator !== 'isnotnull'">
      <b-form-radio-group
        :modelValue="changedValue"
        :options="radioOptions"
        @update:modelValue="change"
      ></b-form-radio-group>
    </div>
  </div>
</template>
<script lang="ts">
import { FILTER_OPERATOR_FOR_BOOLEAN } from '../../../FilterRuleService'
import { FilterItemService } from '../../../FilterItemService'

export default {
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      operator: null,
      radioOptions: [
        { text: 'TRUE', value: 1 },
        { text: 'FALSE', value: 0 },
      ],
    }
  },
  computed: {
    filterItemService(): FilterItemService<any> {
      // @ts-ignore
      return (
        // @ts-ignore
        this.$provides?.filterItemService?.value || this.$provides?.filterObject?.value
      )
    },
    changedValue() {
      return this.modelValue ? (this.modelValue === 'true' ? 1 : 0) : null
    },
    options() {
      // { value: xxxx'', text: 'xxxxx' }のような形で返す
      return Object.keys(FILTER_OPERATOR_FOR_BOOLEAN).map((operator) => {
        return {
          value: operator,
          text: FILTER_OPERATOR_FOR_BOOLEAN[operator],
        }
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.operator =
        this.filterItemService?.value?.operator || this.options[0].value
    })
  },
  methods: {
    change(value) {
      this.$nextTick(() => {
        this.$emit('update:modelValue', {
          value: value === 1 ? 'true' : 'false',
          operator: this.operator,
        })
      })
    },
    updateOperator(value) {
      this.operator = value
      this.$emit('update:operator', this.operator)
    },
    onDismissDropDown() {
      this.$emit('onDismissDropdown')
    },
  },
}
</script>
